import { useState } from 'react'

import { Icon } from 'components/atoms/Icon'
import type { FAQProps, FAQItemProps } from './types'
import { Section } from 'components/organisms/Section'
import { cn } from 'lib/utils'

import './index.scss'

const mainClass = 'faq'

export const FAQ = ({ title, subtitle, note, action, list = [] }: FAQProps) => {
  const [activeItemId, setActiveItemId] = useState<string | null>(null)

  const handleToggle = (id: string) => {
    setActiveItemId((prevId) => (prevId === id ? null : id))
  }

  if (!list.length) {
    return null
  }

  return (
    <Section
      id="_faq"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      {list.map((item) => {
        const isActive = activeItemId === item.id
        return (
          <FAQItem
            key={item.id}
            item={item}
            isActive={isActive}
            onToggle={() => handleToggle(item.id)}
          />
        )
      })}
    </Section>
  )
}

const FAQItem = ({ item, isActive, onToggle }: FAQItemProps) => {
  return (
    <div
      className={cn(`${mainClass}__item`, {
        [`${mainClass}__item--active`]: isActive,
      })}
      data-faq-id={item.id}
    >
      <div className={`${mainClass}__question`}>
        <button
          className={`${mainClass}__question-btn`}
          type="button"
          aria-expanded={isActive}
          aria-controls={item.id}
          onClick={onToggle}
        >
          {item.question}
          <Icon name="arrow" className={`${mainClass}__caret`} />
        </button>
      </div>
      <div
        className={cn(`${mainClass}__answer`, {
          [`${mainClass}__answer--active`]: isActive,
        })}
        id={item.id}
        aria-hidden={!isActive}
      >
        <div className={`${mainClass}__answer-content`}>
          <p className={`${mainClass}__answer-text`}>{item.answer}</p>
        </div>
      </div>
    </div>
  )
}
